import { graphql } from 'gatsby';

import Template from '../../components/resources/ResourcesPage/ResourcesPage';

export default props => Template(props);

// Unfortunately, Gatsby doesn't let us insert JS variables in this template string, so the query below is quite repetitive:
export const query = graphql`
  query ResourcesPageQuery {
    topics: allSanityResourceTopic {
      nodes {
        title
      }
    }
    types: allSanityResourceType {
      nodes {
        title
        svg
      }
    }
    externalResources: allSanityExternalResource {
      nodes {
        id
        _updatedAt
        image {
          asset {
            _id
          }
        }
        title
        url
        topics {
          title
        }
        type {
          title
          svg
        }
      }
    }
    resourcePages: allSanityResourcePage(
      filter: { meta: { includeInResources: { ne: false } } }
    ) {
      nodes {
        id
        _updatedAt
        meta {
          title
          ogImage {
            asset {
              _id
            }
          }
          slug {
            current
          }
          topics {
            title
          }
          type {
            title
            svg
          }
        }
      }
    }
    webinars: allSanityWebinar {
      nodes {
        id
        _updatedAt
        meta {
          title
          ogImage {
            asset {
              _id
            }
          }
          slug {
            current
          }
          topics {
            title
          }
          type {
            title
            svg
          }
        }
      }
    }
    whitePapers: allSanityWhitePaper {
      nodes {
        id
        _updatedAt
        meta {
          title
          ogImage {
            asset {
              _id
            }
          }
          slug {
            current
          }
          topics {
            title
          }
          type {
            title
            svg
          }
        }
      }
    }
  }
`;
